import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store';
import '@/assets/fonts.scss'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // 默认中文
  messages: {
    zh,
    en
  }
})

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  i18n,
  el:'#app',
  store,
  render: h => h(App),
}).$mount('#app')